
import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';

import { NumberInput } from '@process-advisor/process-miner/modals/numberInput';
import { type Props as MinProps} from '@process-advisor/process-miner/api/methods/modals/setMinPercTasks'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { getFontFamily } from '@process-advisor/process-miner/shared/theme';

const Wrapper = styled.div`
    display: flex;
`;

const StyledNumberInput = styled(NumberInput)`
    font-family: ${getFontFamily('atlassian')};
    margin-right: 10px;
`;

export const MinPercTasks: React.FC = () => {
    const [label, setLabel] = React.useState('');

    let [min, setMinMax] = React.useState<MinProps>({
        min: 0,
    });

    const onChange = _.curry((key: keyof MinProps, value: number) => {
        setMinMax({ ...min, [key]: value });
    });

    const onBlur = _.curry((key: keyof MinProps, value: number) => {
        apiProvider.setMinPercTasks(min);
    });

    React.useEffect(() => {
        setLabel('Min % of ' + apiProvider.getEntityLower() + 's')
    }, []);

    return (
        <Wrapper>
            <StyledNumberInput
                label={label}
                value={min.min}
                onChange={onChange('min')}
                onBlur={onBlur('min')}/>
        </Wrapper>
    );
};
